import {Platform, Linking} from 'react-native';

export function linkHandler(url) {
  if (Platform.OS === 'web') {
    window.open(url, '_blank', '');
  } else {
    Linking.openURL(url);
  }
}
